import { Injectable } from '@angular/core';
import { ApiResponse, ApiResponseStatusCode } from '../core';


/**
 * This service handles base logic of services.
 */
@Injectable({ providedIn: 'root' })
export class BaseService {

	protected _handleApiResponse<T>(response: ApiResponse<T>) {
		if (response.statusCode == ApiResponseStatusCode.Success) {
			return response.result as T;
		} else {
			throw new Error("Generic error");
		}
	}

}
